import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

const Item = styled(Paper)(({ theme }) => ({
  '&:hover': {
    boxShadow: '0 15px 25px 0 rgba(0,0,0,0.1)',
    background: 'rgba(255, 255, 255, 0.1)',
  },
  padding: theme.spacing(4),
  borderRadius: 10,
  minHeight: 230,
}));

interface IProps {
  icon: any;
  title: any;
  desc1: any;
  desc2: any;
}

const Card = ({ title, desc1, desc2, icon }: IProps) => {
  return (
    <Item>
      <Stack spacing={3} justifyContent="center" alignItems="center">
        {icon}
        <Typography variant="h3">{title}</Typography>
        <Box>
          <Typography textAlign="center">{desc1}</Typography>
          <Typography textAlign="center">{desc2}</Typography>
        </Box>
      </Stack>
    </Item>
  );
};

export default Card;
